import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ProductAdminManager } from "@/components/admin/product-manager";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { PillTabsList, PillTabsTrigger } from "@/components/admin/pill-tabs";

export const Route = createFileRoute("/_authenticated/admin/hosting")({
  component: HostingPage,
});

function HostingPage() {
  const [tab, setTab] = useState<"hosting" | "vps">("hosting");
  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={(v) => setTab(v as any)}>
        <PillTabsList search>
          <PillTabsTrigger value="hosting">Hosting plans</PillTabsTrigger>
          <PillTabsTrigger value="vps">VPS plans</PillTabsTrigger>
        </PillTabsList>
        <TabsContent value="hosting" className="pt-4">
          <ProductAdminManager kind="hosting" />
        </TabsContent>
        <TabsContent value="vps" className="pt-4">
          <ProductAdminManager kind="vps" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
